import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetCompanionSessionQuery,
  GetCompanionSessionQueryVariables,
} from "./GetCompanionSession.generated";

export const GET_COMPANION_SESSION: TypedDocumentNode<
  GetCompanionSessionQuery,
  GetCompanionSessionQueryVariables
> = gql`
  query getCompanionSession($companionSessionUuid: String!) {
    companionSession(companionSessionUuid: $companionSessionUuid) {
      companionSessionUuid
      user {
        uuid
        firstName
        lastName
      }
      note {
        uuid
      }
      createdAt
      updatedAt
      title
      statusText
      summary
      sessionType
      statusSummary {
        tasks {
          pending
          rejected
          accepted
          started
          failed
          succeeded
        }
        messages {
          processing
          failed
          succeeded
        }
      }
      messages {
        companionSessionMessageUuid
        role
        createdAt
        textContent
        companionType
      }
      inventory {
        inventoryUuid
        status
      }
      attachments {
        uuid
        fileName
      }
      knowledge {
        knowledgeKey
        knowledgeValue
      }
      tasks {
        companionSessionTaskUuid
        name
        createdAt
        updatedAt
        status
        taskStepDescription
      }
      estimates {
        companionSessionEstimateUuid
        createdAt
        updatedAt
        items {
          companionSessionEstimateItemUuid
          quantity
          choices {
            inventoryItemUuid
            inventoryItem {
              productCode
              description
              priceCents
              dispensingFeeCents
            }
            isSelected
          }
        }
      }
    }
  }
`;
export default GET_COMPANION_SESSION;
